import script from "./LoginModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginModal.vue?vue&type=script&setup=true&lang=js"

import "./LoginModal.vue?vue&type=style&index=0&id=b8322ab2&lang=less"

const __exports__ = script;

export default __exports__